import { render, staticRenderFns } from "./PropertiesPageFilter.vue?vue&type=template&id=50b0620e"
import script from "./PropertiesPageFilter.vue?vue&type=script&lang=js"
export * from "./PropertiesPageFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports